import { Role } from 'features/auth/types';
import { PageIntegrationIMPACTRegisterAsClinician } from 'features/integration/impact/public/page-auth';
import { PageIntegrationLandingPage } from 'features/integration/impact/public/page-landing';
import { PageIntegrationIMPACTPatientAdd } from 'features/integration/impact/public/page-patient-add';
import { PageIntegrationPilotConsent } from 'features/integration/impact/public/page-pilot-consent';
import { PrivateRouteProps } from 'navigation/router/components/routes/private-route';
import { PublicRouteProps } from 'navigation/router/components/routes/public-route';
import { IntegrationRoutes } from 'routes';

export const INTEGRATION_ROUTES: (
  | (PrivateRouteProps & { type: 'private' })
  | (PublicRouteProps & { type: 'public' })
)[] = [
  {
    type: 'private',
    roles: [Role.ClinicAdmin, Role.Clinician],
    path: IntegrationRoutes.IMPACT_PATIENT_IMPORT,
    component: PageIntegrationIMPACTPatientAdd,
    redirectPath: IntegrationRoutes.IMPACT_LANDING_SIGNIN,
    redirectShouldPreserveSearchQuery: true
  },
  {
    type: 'private',
    roles: [Role.Clinician, Role.ClinicAdmin],
    path: IntegrationRoutes.IMPACT_JOIN,
    component: PageIntegrationPilotConsent,
    redirectPath: IntegrationRoutes.IMPACT_LANDING_SIGNIN,
    redirectShouldPreserveSearchQuery: true
  },
  {
    type: 'public',
    path: IntegrationRoutes.IMPACT_LANDING,
    component: PageIntegrationLandingPage,
    redirectPath: '/'
  },
  {
    type: 'public',
    path: IntegrationRoutes.IMPACT_LANDING_SIGNIN,
    component: PageIntegrationIMPACTRegisterAsClinician,
    redirectPath: IntegrationRoutes.IMPACT_JOIN,
    publicOnly: true,
    redirectShouldPreserveSearchQuery: true
  }
];
